import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  invoiceNoContainer: {
    flexDirection: "row",
    marginTop: 12,
    justifyContent: "flex-start",
  },
  invoiceDateContainer: {
    flexDirection: "row",
    justifyContent: "flex-start",
  },
  invoiceDate: {
    fontSize: 12,
    fontStyle: "bold",
  },
  label: {
    // width: 150,
  },
});

const InvoiceNo = ({ invoice }) => (
  <Fragment>
    <View>
      <Text style={styles.label}>Brodie Birkett</Text>
      <Text style={styles.label}>brodieb777@hotmail.com</Text>
    </View>
    <View style={styles.invoiceNoContainer}>
      <Text style={styles.label}>Invoice No: </Text>
      <Text style={styles.invoiceDate}>{invoice.invoiceNumber}</Text>
    </View>
    <View style={styles.invoiceDateContainer}>
      <Text style={styles.label}>Invoice Period: </Text>
      <Text>{invoice.invoicePeriod}</Text>
    </View>
  </Fragment>
);

export default InvoiceNo;
